import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      insightsSubscribe: this.el.querySelector('.insights-subscribe')
    };
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  }

  addListeners() {
    // window.addEventListener('scroll', ::this.handleScroll);
  }

  handleScroll() {
    const padding = 160;
    const topOffset = this.el.offsetTop;
    const bottomOffset =
      this.el.offsetTop +
      this.el.offsetHeight -
      this.dom.insightsSubscribe.offsetHeight -
      padding;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;

    if (window.pageYOffset < topOffset) {
      if (
        this.dom.insightsSubscribe.classList.contains(
          'insights-subscribe--sticky'
        )
      ) {
        this.dom.insightsSubscribe.classList.remove(
          'insights-subscribe--sticky'
        );
      }
    } else if (
      window.pageYOffset >= topOffset &&
      window.pageYOffset < bottomOffset
    ) {
      this.dom.insightsSubscribe.style.top = '';
      if (
        !this.dom.insightsSubscribe.classList.contains(
          'insights-subscribe--sticky'
        )
      ) {
        this.dom.insightsSubscribe.classList.add('insights-subscribe--sticky');
      }
    } else {
      this.dom.insightsSubscribe.style.top = `${
        bottomOffset - window.pageYOffset
      }px`;
      if (
        !this.dom.insightsSubscribe.classList.contains(
          'insights-subscribe--sticky'
        )
      ) {
        this.dom.insightsSubscribe.classList.add('insights-subscribe--sticky');
      }
    }

    if (window.pageYOffset >= topOffset && window.pageYOffset <= bottomOffset) {
      if (scroll < this.scrollTop) {
        this.dom.insightsSubscribe.classList.add(
          'insights-subscribe--translate'
        );
      } else {
        this.dom.insightsSubscribe.classList.remove(
          'insights-subscribe--translate'
        );
      }
    } else {
      this.dom.insightsSubscribe.classList.remove(
        'insights-subscribe--translate'
      );
    }

    this.scrollTop = scroll;
  }
}

export default Module;
